import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import locale from "@bonliva-crm/locale";

export interface Props {
  open: boolean;
  anchor: Element;

  onClose: () => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
}

export const SubVersionRowMenu = (props: Props) => {
  return (
    <Menu anchorEl={props.anchor} open={props.open} onClose={props.onClose}>
      <MenuItem onClick={props.onEdit}>{locale.Edit}</MenuItem>

      <MenuItem onClick={props.onDuplicate}>{locale.Duplicate}</MenuItem>

      <MenuItem onClick={props.onDelete}>{locale.Delete}</MenuItem>
    </Menu>
  );
};
